import React from "react";
import { FaLinkedin, FaWhatsapp, FaRegEnvelope } from "react-icons/fa";
import styled from "@emotion/styled";
import ScrollAnimation from "react-animate-on-scroll";

const SocialContainer = styled.div`
  position: fixed;
  top: 48%;
  left: 1.5rem;
  transform: translateY(-50%);

  ul {
    display: block;
  }

  .item + .item {
    margin-top: 1rem;
  }

  a {
    font-size: 2.5rem;
    color: rgb(119, 119, 121);
  }

  a.linkedIn-icon:hover {
    color: #0077b5;
  }

  a.email-icon:hover {
    color: #ea4335;
  }

  a.whatsapp-icon:hover {
    color: #25d366;
  }

  @media screen and (max-width: 1000px) {
    margin-top: 2rem;
    position: relative;
    top: 0;
    left: 0;
    ul {
      display: flex;
      justify-content: center;
      align-items: center;
      list-style: none;
    }

    a {
      font-size: 2.5rem;
      color: #151418;
      &:hover {
        color: rgb(57, 134, 250);
      }
    }

    .item + .item {
      margin-top: 0;
      margin-left: 2rem;
    }
  }
`;
function FixSocialIcon() {
  return (
    <SocialContainer>
      <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
        <ul>
          <li className="item">
            <a
              className="linkedIn-icon"
              href="https://www.linkedin.com/in/nikunj-nadiyapara-8b9b412a9/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin />
            </a>
          </li>
          <li className="item">
            <a
              className="email-icon"
              href={`mailto:nikunjnadiyapara.work@gmail.com?&subject=Inquiry about&body=I need to discuss with you regarding`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaRegEnvelope />
            </a>
          </li>
          <li className="item">
            <a
              className="whatsapp-icon"
              href="https://api.whatsapp.com/send?phone=9099670684&text=Hi%20Nikunj.%0D%0A%0D%0AI%20want%20to%20discuss%20with%20you%20regarding%20"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp />
            </a>
          </li>
        </ul>
      </ScrollAnimation>
    </SocialContainer>
  );
}

export default FixSocialIcon;
